import React from 'react'
import { Link } from 'react-router-dom'

import FontAwesomeIcon from '@fortawesome/react-fontawesome';






class Header extends React.Component {


  render() {

    var boldText = {
      fontWeight: 'bold'
    };
    return (
      <nav className="pt-navbar @blue1">
        <div className="pt-navbar-group pt-align-left">
          <div className="pt-navbar-heading">forrest<span style={boldText} >smietanski</span></div>
          <span className="pt-navbar-divider"></span>
          <a className="pt-button pt-minimal" href="https://twitter.com/smietanskif"><FontAwesomeIcon icon={["fab", "twitter"]} /></a>
          <a className="pt-button pt-minimal" href="https://www.instagram.com/smietanskif"><FontAwesomeIcon icon={["fab", "instagram"]} /></a>
          <a className="pt-button pt-minimal" href="https://github.com/smietanski"><FontAwesomeIcon icon={["fab", "github"]} /></a>
          {this.props.authenticated
            ? null
            : null
          }
        </div>
        {
          this.props.authenticated
            ? (
              <div className="pt-navbar-group pt-align-right">
                <Link className="pt-button pt-minimal pt-icon-home" aria-label="Home" to={'/home'}></Link>
                <Link className="pt-button pt-minimal" to={'/about'}>About</Link>
                <Link className="pt-button pt-minimal" to={'/contact'}>Contact</Link>   
                <Link className="pt-button pt-minimal" to={'/blog'}>Blog</Link>
                <Link className="pt-button pt-minimal" to={'/projects'}>Projects</Link>
                <Link className="pt-button pt-minimal" to={'/store'}>Store</Link>
                <span className="pt-navbar-divider"></span>
                <Link className="pt-button pt-minimal pt-icon-user" to={'/user'}></Link>
                <Link className="pt-button pt-minimal pt-icon-log-out" aria-label="Log Out" to={'/logout'}></Link>

              </div>
            )
            : (
              <div className="pt-navbar-group pt-align-right">
                <Link className="pt-button pt-minimal pt-icon-home" aria-label="Home" to={'/home'}></Link>
                <Link className="pt-button pt-minimal" to={'/about'}>About</Link>
                <Link className="pt-button pt-minimal" to={'/contact'}>Contact</Link>   
                <Link className="pt-button pt-minimal" to={'/blog'}>Blog</Link>
                <Link className="pt-button pt-minimal" to={'/projects'}>Projects</Link>
                <Link className="pt-button pt-minimal" to={'/store'}>Store</Link>
                <span className="pt-navbar-divider"></span>
                <Link className="pt-button pt-intent-primary" to="/login">Register/ Login</Link>
              </div>

            )
        }
      </nav>
    );
  }
}


export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.jsx